import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import AuthLayout from '../../../components/auth/AuthLayout';

const DEMO_AADHAAR_OTP = '654321';

const SignupAadhaar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { mobile, panDetails } = location.state || {};
  const [aadhaar, setAadhaar] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!mobile) {
      navigate('/signup', { replace: true });
    }
  }, [mobile, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (aadhaar.trim().length !== 12) {
      toast.error('Please enter a 12-digit Aadhaar number');
      return;
    }

    setLoading(true);

    try {
      // TODO: Replace with actual API call
      // const response = await authServices.sendAadhaarOtp(aadhaar.trim());

      await new Promise(resolve => setTimeout(resolve, 1000));

      toast.success('Aadhaar OTP sent');
      toast.info(`Demo Aadhaar OTP is ${DEMO_AADHAAR_OTP}`);

      navigate('/signup/aadhaar-otp', {
        state: {
          mobile,
          panDetails,
          aadhaarNumber: aadhaar.trim(),
          demoAadhaarOtp: DEMO_AADHAAR_OTP
        }
      });
    } catch (error) {
      toast.error('Failed to send OTP. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Verify Aadhaar"
      subtitle="Enter your Aadhaar number to receive OTP"
      onBack={() => navigate(-1)}
    >
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Aadhaar Number</label>
          <input
            type="tel"
            className="form-input"
            value={aadhaar}
            maxLength={12}
            onChange={(event) => {
              const value = event.target.value.replace(/\D/g, '');
              setAadhaar(value);
            }}
            placeholder="Enter Aadhaar number"
            required
          />
        </div>
        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Sending OTP...' : 'Send OTP'}
        </button>
      </form>
      <div className="signup-section" style={{ marginTop: '1.5rem' }}>
        <p className="signup-text">
          Don&apos;t have Aadhaar OTP?{' '}
          <button
            type="button"
            className="signup-link"
            onClick={() => navigate('/signup/aadhaar-upload', { state: { mobile, panDetails } })}
          >
            Skip and upload Aadhaar
          </button>
        </p>
      </div>
    </AuthLayout>
  );
};

export default SignupAadhaar;


